<ng-template #control let-formControlName="formControlName" let-multipleTaxableValues="hasMultipleTaxableValues" let-allowNegative="allowNegative">
    @if (editMode()) {
        <div [formGroup]="invoiceForm()"
             class="d-flex see-details-wrapper"
             [class.see-details]="multipleTaxableValues && showSeeDetails(formControlName)">
            <input type="text"
                   class="form-control text-end"
                   [attr.data-qa]="'invoice-details-' + formControlName"
                   [ngClass]="{ overridden: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Manual, calculated: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Auto }"
                   currencyMask
                   [options]="{ allowNegative: (allowNegative || false), precision: 0, prefix: '' }"
                   [formControlName]="formControlName">
            @if (multipleTaxableValues && showSeeDetails(formControlName)) {
                <span class="see-details-overlay" [class.see-details-disabled]="formControlName === 'siteChangeTAV'">{{ seeDetailsText }}</span>
            }
        </div>
    } @else {
        <div class="text-end"
             [ngClass]="{ overridden: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Manual, calculated: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Auto }">
            @if (multipleTaxableValues && showSeeDetails(formControlName)) {
                <span [attr.data-qa]="'invoice-details-' + formControlName">See Details...</span>
            } @else {
                <span [attr.data-qa]="'invoice-details-' + formControlName">{{ invoiceForm().get(formControlName)?.value | number: '1.0-0' }}</span>
            }
        </div>
    }
</ng-template>

<ng-template #currencyControl let-formControlName="formControlName" let-multipleTaxableValues="hasMultipleTaxableValues">
    @if (editMode()) {
        <div [formGroup]="invoiceForm()" class="d-flex see-details-wrapper">
            <input type="text"
                   class="form-control text-end"
                   [attr.data-qa]="'invoice-details-' + formControlName"
                   [ngClass]="{ overridden: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Manual, calculated: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Auto }"
                   currencyMask
                   [options]="{ allowNegative: false, precision: 2, prefix: '$' }"
                   [formControlName]="formControlName">
            @if (multipleTaxableValues && showSeeDetails(formControlName)) {
                <span class="see-details-overlay">{{ seeDetailsText }}</span>
            }
        </div>
    } @else {
        <div class="text-end"
             [ngClass]="{ overridden: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Manual, calculated: !(multipleTaxableValues && showSeeDetails(formControlName)) && overrides[formControlName] === overrideStatus.Auto }">
            @if (multipleTaxableValues && showSeeDetails(formControlName)) {
                <span [attr.data-qa]="'invoice-details-' + formControlName">See Details...</span>
            } @else {
                <span [attr.data-qa]="'invoice-details-' + formControlName">{{ invoiceForm().get(formControlName)?.value | currency:'USD' }}</span>
            }
        </div>
    }
</ng-template>

<ng-template #override let-formControlName="formControlName" let-resetControls="resetControls" let-emitEvent="emitEvent">
    @if (overrides[formControlName] === overrideStatus.Manual && !invoiceForm().get(formControlName)?.disabled) {
        <button type="button"
                class="ace-btn btn-sm has-icon btn-primary btn-danger"
                [attr.data-qa]="'invoice-details-reset-override-' + formControlName"
                (click)="resetOverride(resetControls || [formControlName], emitEvent)">
            <i class="fa fa-undo"></i>
        </button>
    }
</ng-template>

<form class="invoice-details-form" [formGroup]="invoiceForm()">
    <table class="w-100">
        <thead>
            <th></th>
            <th class="text-right">MV</th>
            @if (editMode()) {
                <th></th>
            }
            <th class="text-right">Taxable AV</th>
            @if (editMode()) {
                <th></th>
            }
        </thead>
        <tbody>
        <tr>
            <td><label for="site-previous" class="text-nowrap">Site Previous:</label></td>
            <td>
                <ng-container
                    [ngTemplateOutlet]="control"
                    [ngTemplateOutletContext]="{ formControlName: 'previousMV', hasMultipleTaxableValues: false }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td>
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'previousMV' }">
                    </ng-container>
                </td>
            }
            <td>
                <ng-container
                    [ngTemplateOutlet]="control"
                    [ngTemplateOutletContext]="{ formControlName: 'previousTAV', hasMultipleTaxableValues: hasMultipleTaxableValues }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td>
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'previousTAV' }">
                    </ng-container>
                </td>
            }
        </tr>
        <tr>
            <td><label for="site-billable" class="text-nowrap">Site Billable:</label></td>
            <td>
                <ng-container
                    [ngTemplateOutlet]="control"
                    [ngTemplateOutletContext]="{ formControlName: 'invoiceMV', hasMultipleTaxableValues: false }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td>
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'invoiceMV' }">
                    </ng-container>
                </td>
            }
            <td>
                <ng-container
                    [ngTemplateOutlet]="control"
                    [ngTemplateOutletContext]="{ formControlName: 'invoiceTAV', hasMultipleTaxableValues: hasMultipleTaxableValues }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td>
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'invoiceTAV' }">
                    </ng-container>
                </td>
            }
        </tr>
        <tr>
            <td><label for="site-change" class="text-nowrap">Site Change:</label></td>
            <td>
                <ng-container
                    [ngTemplateOutlet]="control"
                    [ngTemplateOutletContext]="{ formControlName: 'siteChangeMV', hasMultipleTaxableValues: false, allowNegative: true }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td></td>
            }
            <td>
                <ng-container
                    [ngTemplateOutlet]="control"
                    [ngTemplateOutletContext]="{ formControlName: 'siteChangeTAV', hasMultipleTaxableValues: hasMultipleTaxableValues, allowNegative: true }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td></td>
            }
        </tr>
        <tr>
            <td><label for="billable-rate" class="text-nowrap">Billable Rate:</label></td>
            @if (hasAnyTaxableAssessedValue) {
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
            }
            <td>
                @if (editMode()) {
                    <div [formGroup]="invoiceForm()"
                         class="d-flex see-details-wrapper"
                         [class.see-details]="(hasMultipleBaseRates || hasMultipleTaxableValues) && showSeeDetails('billableTaxRate')">
                        <input type="text"
                               data-qa="invoice-details-billableTaxRate"
                               [ngClass]="{ overridden: !((hasMultipleBaseRates || hasMultipleTaxableValues) && showSeeDetails('billableTaxRate')) && overrides.billableTaxRate === overrideStatus.Manual, calculated: !(hasMultipleTaxableValues && showSeeDetails('billableTaxRate')) && overrides.billableTaxRate === overrideStatus.Auto }"
                               class="form-control text-end"
                               toPercentage
                               [precision]="6"
                               formControlName="billableTaxRate">
                        @if ((hasMultipleBaseRates || hasMultipleTaxableValues) && showSeeDetails('billableTaxRate')) {
                            <span class="see-details-overlay">{{ seeDetailsText }}</span>
                        }
                    </div>
                } @else {
                    <div class="text-end"
                         [ngClass]="{ overridden: !(hasMultipleTaxableValues && showSeeDetails('billableTaxRate')) && overrides.billableTaxRate === overrideStatus.Manual, calculated: !(hasMultipleTaxableValues && showSeeDetails('billableTaxRate')) && overrides.billableTaxRate === overrideStatus.Auto }">
                        @if ((hasMultipleBaseRates || hasMultipleTaxableValues) && showSeeDetails('billableTaxRate')) {
                            <span data-qa="invoice-details-billableTaxRate">See Details...</span>
                        } @else {
                            <span data-qa="invoice-details-billableTaxRate">{{ invoiceForm().get('billableTaxRate')?.value | percent: '1.6-6' }}</span>
                        }
                    </div>
                }
            </td>
            @if (editMode()) {
                <td>
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'billableTaxRate', resetControls: ['taxSavingsTotal', 'billableTaxRate'], emitEvent: false }">
                    </ng-container>
                </td>
            }
            @if (!hasAnyTaxableAssessedValue) {
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
            }
        </tr>
        <tr>
            <td><label for="tax-savings" class="text-nowrap">Tax Savings:</label></td>
            @if (hasAnyTaxableAssessedValue) {
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
            }
            <td>
                <ng-container
                    [ngTemplateOutlet]="currencyControl"
                    [ngTemplateOutletContext]="{ formControlName: 'taxSavingsTotal' }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td>
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'taxSavingsTotal', resetControls: ['taxSavingsTotal', 'billableTaxRate'], emitEvent: false }">
                    </ng-container>
                </td>
            }
            @if (!hasAnyTaxableAssessedValue) {
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
            }
        </tr>

        <tr>
            <td [attr.colspan]="editMode() ? 5 : 3">
                <hr class="my-4" />
            </td>
        </tr>

        @if (!currentInvoice().isAdHoc) {
            <tr>
                <td><label for="contingency">Contingency %:</label></td>
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
                <td class="text-right pe-0">
                    @if (editMode()) {
                        <input type="text"
                               data-qa="invoice-details-contingencyPct"
                               class="form-control"
                               style="width: 100%; text-align: right;"
                               formControlName="contingencyPct"
                               [ngClass]="{ overridden: overrides.contingencyPct === overrideStatus.Manual, calculated: overrides.contingencyPct === overrideStatus.Auto }"
                               toPercentage
                               [precision]="2" />
                    } @else {
                        <span data-qa="invoice-details-contingencyPct"
                            [ngClass]="{ overridden: overrides.contingencyPct === overrideStatus.Manual, calculated: overrides.contingencyPct === overrideStatus.Auto }">
                            {{ currentInvoice().contingencyPct | percent: '1.2-2' }}
                        </span>
                    }
                </td>
                @if (editMode()) {
                    <td class="px-0">
                        <ng-container
                            [ngTemplateOutlet]="override"
                            [ngTemplateOutletContext]="{ formControlName: 'contingencyPct' }">
                        </ng-container>
                    </td>
                }
            </tr>
            <tr>
                <td><label for="contingency-cap">Contingency Cap:</label></td>
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
                <td class="text-right pe-0">
                    <ng-container
                        [ngTemplateOutlet]="currencyControl"
                        [ngTemplateOutletContext]="{ formControlName: 'contingencyCap' }">
                    </ng-container>
                </td>
                @if (editMode()) {
                    <td class="px-0">
                        <ng-container
                            [ngTemplateOutlet]="override"
                            [ngTemplateOutletContext]="{ formControlName: 'contingencyCap' }">
                        </ng-container>
                    </td>
                }
            </tr>
            <tr>
                <td><label for="contingency-fee">Contingency Fee Amount:</label></td>
                <td></td>
                @if (editMode()) {
                    <td></td>
                }
                <td class="text-right pe-0">
                    <ng-container
                        [ngTemplateOutlet]="currencyControl"
                        [ngTemplateOutletContext]="{ formControlName: 'feeAmount' }">
                    </ng-container>
                </td>
                @if (editMode()) {
                    <td class="px-0">
                        @if (overrides.feeAmount === overrideStatus.Manual) {
                            <button type="button"
                                    data-qa="invoice-details-reset-override-feeAmount"
                                    class="ace-btn btn-sm has-icon btn-primary btn-danger"
                                    (click)="resetFeeAmount()">
                                <i class="fa fa-undo"></i>
                            </button>
                        }
                    </td>
                }
            </tr>
        }
        <tr>
            <td><label for="fixed-fee">Fixed Fee Amount:</label></td>
            <td></td>
            @if (editMode()) {
                <td></td>
            }
            <td class="text-right pe-0">
                <ng-container
                    [ngTemplateOutlet]="currencyControl"
                    [ngTemplateOutletContext]="{ formControlName: 'fixedFee' }">
                </ng-container>
            </td>
            @if (editMode()) {
                <td class="px-0">
                    <ng-container
                        [ngTemplateOutlet]="override"
                        [ngTemplateOutletContext]="{ formControlName: 'fixedFee' }">
                    </ng-container>
                </td>
            }
        </tr>
        <tr>
            <td><label for="expense-amount">Expense Amount:</label></td>
            <td></td>
            @if (editMode()) {
                <td></td>
            }
            <td class="text-right pe-0">
                @if (editMode()) {
                    <div class="d-flex">
                        <input type="text"
                               data-qa="invoice-details-expenseAmount"
                               class="form-control text-end"
                               currencyMask
                               [options]="{ allowNegative: true, precision: 2, prefix: '$' }"
                               formControlName="expenseAmount">
                    </div>
                } @else {
                    <div class="text-end">
                        <span data-qa="invoice-details-expenseAmount">{{ invoiceForm().get('expenseAmount')?.value | currency:'USD' }}</span>
                    </div>
                }
            </td>
            @if (editMode()) {
                <td class="px-0"></td>
            }
        </tr>
        <tr>
            <td><label for="invoice-amount">Invoice Amount:</label></td>
            <td></td>
            @if (editMode()) {
                <td></td>
            }
            <td class="text-right pe-0">
                @if (editMode()) {
                    <input type="text"
                           data-qa="invoice-details-expenseAmount"
                           class="form-control text-end"
                           [ngClass]="{ calculated: overrides.invoiceAmount === overrideStatus.Auto }"
                           [value]="currentInvoice().invoiceAmount | currency:'USD'"
                           disabled>
                } @else {
                    <div class="text-end">
                        <span data-qa="invoice-details-invoiceAmount"
                              [ngClass]="{ calculated: overrides.invoiceAmount === overrideStatus.Auto }">
                            {{ currentInvoice().invoiceAmount | currency:'USD' }}
                        </span>
                    </div>
                }
            </td>
            @if (editMode()) {
                <td class="px-0"></td>
            }
        </tr>
        </tbody>
    </table>
</form>
